export default __webpack_public_path__ + "static/1950_1960-b4aa5a9fc7adff32ad7888d3a6100d09.mp4";